'use client';
import EcoImg from 'eco-design/base/eco-img';
import DefaultStyle from 'lowcode/common/DefaultStyle';
import EditorLink from 'lowcode/components/EditorLink';
import { useEffect, useState, useRef } from 'react';
import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/scss';
import { times } from 'lodash';
import cookie from 'react-cookies';

import { TextLang } from 'lowcode/OldMember/TextLang';
import { getLang } from 'lowcomp/plugins/member/utils';
import { StatGetDeviceId } from 'eco-design-micro/EcoStat/config';

import { getRewardUserInfo, getRewardUserLevel, getAIUserInfo, queryShopifyProductList } from '@/service/vip';
import { getIsLogin } from '@/utils/cookie';
import generateTraceId from '@/utils/singUtil/generateTraceId';
import { loginUser } from '@/utils/cookie';
import { getGloAIProductList } from '@/appSetting/get-global-ai/getGloAIProductList';
import { getGloProductList } from '@/appSetting/get-global-data/getGloProductList';
import getLocal from '@/app/utils/getLocal';
import gtm from '@/utils/gtm';
import { productRes2 } from '@/app/eflayout/Header/DropBox/DropBoxSearch/mock';

import styles from './index.module.scss';

const WEB_HOST = process.env.NEXT_PUBLIC_WEB_HOST;

export default function Content({ id, data, attr, theme }: any) {
    const { title } = data;
    // 最多8个
    const [gap, setGap] = useState(0);
    const [swiper, setSwiper] = useState<any>({});
    const [terminal, setTerminal] = useState(0);
    const [disable, setDisable] = useState('prev');
    const [list, setList] = useState<any[]>([]);
    const userId = loginUser()?.user?.userId;
    const { locale = '' } = getLocal();

    const sectionRef = useRef<HTMLDivElement>(null);
    const [timer, setTimer] = useState<NodeJS.Timeout | null>(null);
    const [hasTracked, setHasTracked] = useState(false);
    const t = getLang(TextLang, locale);
    const [showType, setShowType] = useState('');

    const handleNext = () => {
        if (swiper && swiper.activeIndex != null) {
            const nextIndex = Math.min(swiper.activeIndex + 4, list.length - terminal); // terminal 个元素为一屏
            swiper.slideTo(nextIndex);
            setDisable(nextIndex >= list.length - (terminal + 1) ? 'next' : '');
        }
    };

    const handlePrev = () => {
        if (swiper && swiper.activeIndex != null) {
            const prevIndex = Math.max(swiper.activeIndex - 4, 0);

            swiper.slideTo(prevIndex);
            setDisable(prevIndex <= 0 ? 'prev' : '');
        }
    };

    const queryAIResult = async (data?: any) => {
        try {
            const deviceId = await StatGetDeviceId({});

            const params = {
                triggerPage: 'Brand Home Recommend',
                tid: generateTraceId(),
                userId,
                deviceId: deviceId || '',
                ...data,
            };

            const productRes = await getGloAIProductList(params, locale);
            if (productRes?.code === '0') {
                const formatList: any = handleFormatProductList(productRes?.data?.items || []);
                if (formatList?.length > 0) {
                    let finalList = formatList;
                    if (formatList?.length > 8) {
                        finalList = formatList.slice(0, 8);
                    }

                    setList(finalList || []);
                    setShowType(finalList[0]?.itemType);
                } else {
                    handleQueryProductList();
                }
            } else {
                handleQueryProductList();
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleQueryProductList = async () => {
        // 产品要求首页版位兜底数据从品牌官网产品改为shopify产品
        // const gloproductlist = await getGloProductList(locale);
        // handleQueryGlobalProduct(gloproductlist);
        const res = await queryShopifyProductList(locale);
        if (res?.code === '0') {
            const productList = res?.data || [];
            setShowType('shopifyProduct');
            handleFormatFallBackProductList(productList);
        } else {
        }
    };

    const handleFormatFallBackProductList = (productList: any[]) => {
        const formatList: any[] = [];
        productList.forEach((item: any) => {
            formatList.push({
                itemId: item?.variantId,
                itemType: 'shopifyProduct',
                variants: [item],
            });
        });

        setList(formatList?.slice(0, 8));
    };
    // 产品要求首页版位兜底数据从品牌官网产品改为shopify产品
    // const handleQueryGlobalProduct = (gloproductlist: any[]) => {
    //     const powerKitSeriesUrl = (generalKey: string) => {
    //         if (/^product_pk_/.test(generalKey)) {
    //             return 'ecoflow-power-kits/series';
    //         }
    //         return false;
    //     };

    //     const spuList = gloproductlist?.map((item: any) => {
    //         const url = powerKitSeriesUrl(item.generalKey);
    //         return {
    //             ...item,
    //             ...(url ? { url } : {}),
    //         };
    //     });

    //     const flatCategoryList = spuList?.map((item: any) => ({
    //         ...item,
    //         type: 'category',
    //         selectable: false,
    //     }));

    //     const filterAccessories = (spuList: any, flatCategoryList: any) => {
    //         if (!spuList.length) return [];
    //         const filterSpuList = spuList.filter((item: any) => !['product_ps_river_river_512', 'product_ps_river_river_768'].includes(item.generalKey));
    //         if (!flatCategoryList.length) return filterSpuList;
    //         return filterSpuList.filter((item: any) => item.accessoryFlag === false);
    //     };

    //     const filteredList = filterAccessories(spuList, flatCategoryList);

    //     const data = filteredList.map((spu: any) => ({
    //         ...spu,
    //         itemId: spu.spuId,
    //         productName: spu.name,
    //         itemType: 'product',
    //         url: `${WEB_HOST}/${locale}/${spu?.url}`,
    //         productImages: spu.images,
    //     }));
    //     let finalList = data;

    //     if (data?.length > 8) {
    //         finalList = data?.slice(0, 8);
    //     }
    //     setList(finalList);
    // };

    const handleFormatProductList = (data: any) => {
        const newList = data?.filter((item: any) => item.itemType === 'product' || item.itemType === 'shopifyProduct') || [];

        return newList;
    };

    const handleSwiperChange = () => {
        const { activeIndex } = swiper;
        if (activeIndex <= 0) {
            setDisable('prev');
        } else if (activeIndex >= list.length - terminal) {
            setDisable('next');
        } else {
            setDisable('');
        }
    };

    const handleQueryVipData = async (sessionId: string | any) => {
        let infoData = null;

        if (!!getIsLogin()) {
            const userInfoRes = await getAIUserInfo(locale as string);
            if (userInfoRes?.code === '0') {
                infoData = userInfoRes?.data;
            }
            await queryAIResult({ ...infoData, sessionId });
        } else {
            await queryAIResult({ sessionId });
        }
    };

    const handleLinkClick = (item: any, index: number) => {
        sessionStorage.setItem('ai_recommend_module', 'AI Brand Home Recommend');

        // 新增 ai cookie 埋点
        const expires = new Date();
        expires.setDate(expires.getDate() + 7);

        const cookieOptions = {
            path: '/',
            domain: '.ecoflow.com',
            expires,
        };

        const aiEntryType =
            showType === 'shopifyProduct' ? 'AI Brand Recommended List_Shopify Product Page' : 'AI Brand Recommended List_Official Website Page';

        cookie.save('ai_entry_type', aiEntryType, { path: '/', domain: '.ecoflow.com' });
        cookie.save('ai_jump_url', item?.url || `https://${locale}.ecoflow.com/products/${item.handle}?variant=${item.variantId}`, {
            path: '/',
            domain: '.ecoflow.com',
        });
        cookie.save('display_type', aiEntryType, cookieOptions);

        if (showType === 'shopifyProduct') {
            gtm.push({
                event: 'uaEvent',
                event_name: 'buy',
                product_name: item?.productTitle || item?.skuTitle || '',
                position: index + 1,
                display_type: 'Shopify Product Page',
                module_referral: 'AI Brand Recommended List',
                jump_module: `https://${locale}.ecoflow.com/products/${item.handle}?variant=${item.variantId}`,
            });
        } else {
            gtm.push({
                event: 'uaEvent',
                event_name: 'click_list',
                button_name: 'Learn More',
                product_name: item?.productName,
                position: index + 1,
                list_type: 'AI Brand Recommended List',
                list_title: title || 'Recommended EcoFlow Products',
                display_type: 'Official Website Page',
            });
        }
    };

    useEffect(() => {
        if (sessionStorage) {
            const session = sessionStorage?.getItem('ef_search_ai_session_id');
            handleQueryVipData(session);
        }

        if (typeof window !== 'undefined') {
            const resetGap = () => {
                const winW = window.innerWidth;
                if (winW > 1440) {
                    setTerminal(3);
                    return setGap(12);
                } else if (winW > 1024) {
                    setTerminal(2);
                    return setGap(12);
                } else if (winW >= 768) {
                    setTerminal(1);
                    return setGap(12);
                } else {
                    setTerminal(0);
                    return setGap(12);
                }
            };
            resetGap();
            window.addEventListener('resize', resetGap);
            return () => {
                window.removeEventListener('resize', resetGap);
                setShowType('');
            };
        }
    }, []);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting && !hasTracked) {
                    const timeout = setTimeout(() => {
                        if (list?.length > 4) {
                            times(4, (i: number) => {
                                gtm.push({
                                    event: 'uaEvent',
                                    event_name: 'view_list',
                                    product_name: list[i]?.productName || 'none',
                                    position: i + 1,
                                    list_type: 'AI Brand Recommended List',
                                    list_title: title || 'Recommended EcoFlow Products',
                                    display_type: showType === 'shopifyProduct' ? 'Shopify Product Page' : 'Official Website Page',
                                });
                            });
                        } else {
                            times(list?.length, (i: number) => {
                                gtm.push({
                                    event: 'uaEvent',
                                    event_name: 'view_list',
                                    product_name: list[i]?.productName || 'none',
                                    position: i + 1,
                                    list_type: 'AI Brand Recommended List',
                                    list_title: title || 'Recommended EcoFlow Products',
                                    display_type: showType === 'shopifyProduct' ? 'Shopify Product Page' : 'Official Website Page',
                                });
                            });
                        }

                        setHasTracked(true); // 避免重复埋点
                    }, 5000);
                    setTimer(timeout);
                } else {
                    // 如果离开视口前未满 5s，则清除定时器
                    if (timer) {
                        clearTimeout(timer);
                        setTimer(null);
                    }
                }
            },
            {
                threshold: 0.5, // 超过一半面积进入视口才触发
            },
        );

        const target = sectionRef.current;
        if (target) {
            observer.observe(target);
        }

        return () => {
            if (target) {
                observer.unobserve(target);
            }
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, [hasTracked, list]);

    return (
        <div
            className={`${styles.content} temp-SwiperCardB 01 temp-hide temp-${theme} temp-${id} GtmModuleData-section`}
            id={id}
            data-section-id="editor-SwiperCardB"
            data-section-id2={id}
            data-section-classname=".SwiperCardB-title"
            ref={sectionRef}
        >
            <DefaultStyle id={id} attr={attr} />
            {title && <h1 className="SwiperCardB-title">{title}</h1>}
            <div className={`SwiperCardB-in`}>
                <Swiper
                    className={`swiper-box ${(terminal >= 2 && list?.length > 4) || (terminal < 2 && list?.length > 1) ? 'over' : ''}`}
                    slidesPerView="auto"
                    modules={[Navigation, Pagination]}
                    navigation={
                        terminal >= 2 && list?.length > 4
                            ? {
                                  prevEl: `temp-${id} .swiper-button-prev`,
                                  nextEl: `temp-${id} .swiper-button-next`,
                              }
                            : false
                    }
                    pagination={true}
                    spaceBetween={gap}
                    // loop={size < 2}
                    onSwiper={(swiperIns) => setSwiper(swiperIns)}
                    onChange={handleSwiperChange}
                >
                    {list?.map((item: any, index: number) => {
                        const currentItem = showType === 'shopifyProduct' ? item?.variants?.[0] : item;

                        const imagesObj = item?.productImages && JSON.parse(item?.productImages);

                        const currentImages =
                            showType === 'shopifyProduct'
                                ? currentItem?.variantImg || currentItem?.img
                                : imagesObj?.transparentImages ||
                                  imagesObj?.images ||
                                  imagesObj?.navigatorImages ||
                                  'https://websiteoss.ecoflow.com/upload/image/1755674891865/recommend_file.png';

                        const currentUrl =
                            showType === 'shopifyProduct'
                                ? `https://${locale}.ecoflow.com/products/${currentItem.handle}?variant=${currentItem.variantId}`
                                : currentItem?.url;
                        return (
                            <SwiperSlide className={`swiper-item`} key={index}>
                                {!!currentImages && (
                                    <div className="banner-img">
                                        <EcoImg pc={currentImages} h5={currentImages} />
                                    </div>
                                )}
                                <div className="banner-ms-box">
                                    <div className="banner-ms-in">
                                        <h2 className="banner-title">
                                            {currentItem?.productName || currentItem?.sceneTitle || currentItem?.productTitle || currentItem?.skuTitle}
                                        </h2>
                                        {currentItem?.variantDescription && <p className="banner-desc">{currentItem?.variantDescription}</p>}
                                        <div className="banner-btns">
                                            {!!currentUrl && (
                                                <EditorLink
                                                    className="SwiperCardB-link-more btn-icon"
                                                    href={currentUrl}
                                                    // dataLayer={{
                                                    //     event: 'uaEvent',
                                                    //     event_name: 'click_list',
                                                    //     button_name: 'Learn More',
                                                    //     product_name: productName,
                                                    //     position: index + 1,
                                                    //     list_type: 'AI Brand Recommended List',
                                                    //     list_title: title || 'Recommended EcoFlow Products',
                                                    // }}
                                                    onClick={() => handleLinkClick(currentItem, index)}
                                                >
                                                    {t('learn_more')}
                                                    {/* <span className="btn-icon-b"></span> */}
                                                </EditorLink>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>
                        );
                    })}
                    {terminal >= 2 && list?.length > 4 && (
                        <>
                            <button
                                className={`swiper-button-prev swipwe-btn ${disable === 'prev' ? 'swiper-button-disabled' : ''}`}
                                onClick={handlePrev}
                            ></button>
                            <button
                                className={`swiper-button-next swipwe-btn ${disable === 'next' ? 'swiper-button-disabled' : ''}`}
                                onClick={handleNext}
                            ></button>
                        </>
                    )}
                </Swiper>
            </div>
        </div>
    );
}
